module.exports = __webpack_public_path__ + "static/img/sprite_adolescent_1_winter.926d780.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adolescents/sprite_adolescent_1_winter.svg
// module id = Ykr6
// module chunks = 1